import React, { Component } from "react";
import close from "../../../../include/images/icon-close.svg";

class Referral extends Component {
  state = {
    data: {
      refer_speciality: "",
      specialist_name: "",
      referral_reason: "",
      doctor_list: [],
    },
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.refferalDetail !== prevProps.refferalDetail &&
      this.props.refferalDetail
    ) {
      const {
        refer_speciality,
        specialist_name,
        referral_reason,
        referalList,
      } = this.props.refferalDetail;

      this.setState({
        data: {
          refer_speciality: refer_speciality || "",
          specialist_name: specialist_name || "",
          referral_reason: referral_reason || "",
          doctor_list: referalList || [],
        },
      });
    }
  }

  render() {
    const { refer_speciality, specialist_name, referral_reason } =
      this.state.data;
    console.log(
      "this.props.refferalDetail.referalList ",
      this.props.refferalDetail.referalList,
    );
    return (
      <>
        <div
          className="sidebar-box list-box"
          id="prescriptions_side_panel_1"
          style={{ right: this.props.referral === true ? "0px" : "-100%" }}
        >
          <div className="sidebar-head d-flex align-items-center">
            <h5>Referral Note</h5>
            <div className="sidebar-right ml-auto d-flex align-items-center">
              <div
                className="close-img"
                onClick={() => {
                  this.props.toggleReferral();
                }}
              >
                <img src={close} alt="Close" />
              </div>
            </div>
          </div>

          <div className="sidebar-body height-auto p-0">
            <div className="sidebar-inner-content">
              <div
                className="chat-box"
                style={{ marginTop: "20px", padding: 15 }}
              >
                {this.state.data.doctor_list.map((item) => {
                  const isSender =
                    item.sender_doctor_id._id === this.props.doctor_id;
                  console.log("item.sender_doctor_id : ",item.sender_doctor_id._id) 
                  console.log("this.props.doctor_id : ",this.props.doctor_id) 
                  console.log("isSender : ",isSender) 
                  return (
                    <div
                      key={item._id}
                      style={{
                        marginBottom: "10px",
                      }}
                    >
                      <div className="fun-box"
                        style={{
                          background: isSender ? "#582BB826" : "#f1f1f1",
                          padding: "10px 30px",
                          borderRadius: "15px",
                          fontSize: "14px",
                        }}
                      >
                        <div className="radio-group-box">
                          <div className="input-group-row">
                            <h5>Refer Speciality</h5>
                            <div className="form-group custom-input mb-0">
                              <input
                                className="form-control"
                                type="text"
                                value={item.receiver_doctor_id.field_type.name}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="radio-group-box">
                          <div className="input-group-row">
                            <h5>Referral For</h5>
                            <div className="form-group custom-input mb-0">
                              <input
                                className="form-control"
                                type="text"
                                value={item.receiver_doctor_id.name}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div className="radio-group-box">
                          <div className="input-group-row">
                            <h5>Referral Reason</h5>
                            <div className="form-group custom-input mb-0">
                              <textarea
                                className="form-control"
                                style={{
                                  marginBottom: "14px",
                                }}
                                value={item.to_purpose}
                                disabled
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#777",
                            marginTop: "5px",
                            textAlign: "right",
                          }}
                        >
                          {new Date(item.createdAt).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {this.props.refferalDetail && (
                <div className="fun-box">
                  <div className="radio-group-box">
                    <div className="input-group-row">
                      <h5>Refer Speciality</h5>
                      <div className="form-group custom-input mb-0">
                        <input
                          className="form-control"
                          type="text"
                          value={refer_speciality}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="radio-group-box">
                    <div className="input-group-row">
                      <h5>Referral For</h5>
                      <div className="form-group custom-input mb-0">
                        <input
                          className="form-control"
                          type="text"
                          value={specialist_name}
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  <div className="radio-group-box">
                    <div className="input-group-row">
                      <h5>Referral Reason</h5>
                      <textarea
                        className="form-control"
                        style={{ padding: "10px", marginBottom: "14px" }}
                        value={referral_reason}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div
          className={
            this.props.referral === true ? "overlay3 show" : "overlay4"
          }
        ></div>
      </>
    );
  }
}

export default Referral;